import { Alert, AlertDescription, type AlertProps } from "@chakra-ui/react";
import { Heading, Text } from "@equidefi/ui";
import type { FC } from "react";

export const IssuerNameAlert: FC<AlertProps & { name: string }> = ({
  name,
  ...rest
}) => (
  <Alert
    status="info"
    borderRadius="lg"
    border="1px solid"
    backgroundColor="purple.50"
    borderColor="purple.500"
    boxShadow="sm"
    my={4}
    {...rest}>
    <AlertDescription alignItems="center" w="full" textAlign="center">
      <Text mb={0}>YOUR INVESTMENT IN</Text>
      <Heading mb={0} fontWeight="bold" textStyle="h1">
        {name}
      </Heading>
    </AlertDescription>
  </Alert>
);
